export default class UserAgent {
  static isMobileDevice () {
    return this.isIOsDevice() || this.isAndroid()
  }

  static isIOsDevice () {
    return this.isIPad() || this.isIphone() || this.isIpod()
  }

  static isAndroid () {
    return /Android/i.test(navigator.userAgent) || this.isAndroidWithDesktopVersionRequested()
  }

  static isIphone () {
    return /iPhone/i.test(navigator.userAgent)
  }

  static isIpod () {
    return /iPod/i.test(navigator.userAgent)
  }

  static isIPad () {
    return /iPad/i.test(navigator.userAgent) || this.iPadWithDesktopVersionRequested()
  }
  
  static iPadWithDesktopVersionRequested () {
    return (navigator.userAgent.includes("Mac") && this.isTactileDevice())
  }

  static isTactileDevice () {
    return 'ontouchend' in document
  }

  static isAndroidWithDesktopVersionRequested () {
    return !this.isIPad() && this.isTactileDevice()
  }

  // @deprecated - use isSmWidth instead
  static isPhoneWidth () {
    return window.innerWidth < 768
  }

  // @deprecated - use isMdWidth instead
  static isTabletWidth () {
    return !UserAgent.isPhoneWidth() && window.innerWidth < 992
  }

  // @deprecated - use isLgWidth or isXlWidth instead
  static isDesktopWidth () {
    return !UserAgent.isPhoneWidth() && !UserAgent.isTabletWidth()
  }

  static isSmWidth () {
    return window.innerWidth < 768
  }

  static isMdWidth () {
    return window.innerWidth >= 768 && window.innerWidth < 992
  }

  static isLgWidth () {
    return window.innerWidth >= 992 && window.innerWidth < 1200
  }

  static isXlWidth () {
    return window.innerWidth >= 1200
  }
}
